import { ReactComponent as IconAPIConfiguration } from '@/assets/svgs/add-api-config-icon.svg'
import { ReactComponent as IconStepper } from '@/assets/svgs/stepper.svg'
import { ReactComponent as IconVerificationIndicator } from "@/assets/svgs/verification-inidicator.svg";
import { ReactComponent as ErrorInfoCircle } from "@/assets/svgs/exclamation-circle-solid-small.svg";
import Button from '@/components/Button'
import Dropdown from '@/components/Dropdown'
import Input from '@/components/Input/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import Portal from '@/components/Portal'
import Select from '@/components/Select'
import SelectorBox3 from '@/components/SelectorBox3'
import Toast2 from '@/components/Toast2'
import Stepper from '@/componentsDS/Stepper/Stepper'
import useConfig from '@/hooks/use-config'
import useModal from '@/hooks/use-modal/index'
import usePage from '@/hooks/use-page'
import usePublicKey from '@/hooks/use-public-key/index'
import { useLocation, useNavigate } from '@/lib/router-dom'
import api from '@/services/api/sourceSystemConfig.js'
import "@/translations/i18n"
import rem from '@/utils/rem.js'
import validateURL from '@/utils/validate-url'
import classname from 'classnames'
import produce from 'immer'
import { useContext, useCallback, useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from "react-i18next"
import { useFeature } from '@/hooks/use-feature/index'
import { featureConstant } from '@/constants/configuration/feature'
import { CustomHeadersToggle } from './components/custom-headers/custom-headers-toggle';
import { CustomHeadersTable } from './components/custom-headers/custom-headers-table';
import { ToastContext } from '@/context/toast/index';
import { CUSTOM_HEADER_ERROR_MESSAGES, CUSTOM_HEADER_MODAL_DETAILS } from '@/constants/custom-headers/index';
import { validateCustomHeaderKey, validateCustomHeaderValue } from '@/utils/custom-headers-validation';

export const ssAuthType = [
	{ label: 'No Auth', value: 'NONE', selected: false },
	{ label: 'API Key', value: 'API_KEY', selected: false },
	{ label: 'JWT (Symmetric)', value: 'JWT_SYM', selected: false },
	{ label: 'JWT (Asymmetric)', value: 'JWT', selected: false },
	{ label: 'JWT and JWE', value: 'JWT_JWE', selected: false },
	{ label: 'OAuth', value: 'OAUTH', selected: false },
]

const Page = () => {

	const isCustomHeadersFeatureEnabled = useFeature(featureConstant.CUSTOM_HEADER_CONFIGURATION);

	/*=================================================
		General
	/================================================*/

	const { t } = useTranslation();
	const [pageTitle, setPageTitle] = useState("")
	const { goTo } = useNavigate();
	const { currentState } = useLocation();
	const TypeEnum = { "PROVIDE": "Provide", "RECEIVE": "Receive", "NOTIFY": "Notify", "NODE": "Comments/Status", "CREATE_PACKAGE": "Create Data Package", "CREATE_FOLDER": "Create Folder", "UPDATE_PACKAGE": "Update Data Package" }

	const existingEditingDE = () => {
		let configuredDEConfig = currentState.data?.endpoints ?? {};
		let existingDE = Object.keys(configuredDEConfig);
		let editingDE = currentState.mode ? existingDE.filter(s => {
			return JSON.stringify(configuredDEConfig[s]) === currentState.data?.groupedItemKey
		}) : []
		return { existingDE, editingDE }
	}

	const provide = 'PROVIDE';
	const receive = 'RECEIVE';

	const [type] = useState(() => {
		if (currentState.type) {
			return currentState.type
		}
		return provide
	});

	const { breadcrumbsItems } = usePage({ title: pageTitle, breadcrumbs: ["API Configuration"] })
	const { register, handleSubmit, reset, watch, setValue, formState: { isValid, dirtyFields } } = useForm({ mode: 'onChange' })
	const { addToastMessage } = useContext(ToastContext)

	const [selectedConfig, setSelectedConfig] = useState("")
	const [inputUrl, setInputUrl] = useState("")
	const [checkboxDataElements, setCheckboxDataElements] = useState([])
	const [authType, setAuthType] = useState("")

	const [pitstopPublicKey, setPitstopPublicKey] = useState()
	const { visible: isVisible, show: showapiConfigCancelModal, hide: hideapiConfigCancelModal } = useModal()
	const { visible: isSubmitModalVisible, show: showApiSubmitModal, hide: hideApiSubmitModal } = useModal()
	const { visible: isCustomHeadersModalVisible, show: showCustomHeadersModal, hide: hideCustomHeadersModal } = useModal()


	const [selectedOption, setOption] = useState('Select type')

	const [oAuthGrantTypeOptions, _setOAuthGrantTypeOptions] = useState([
		{ label: 'Client Credentials', value: 'client_credentials', selected: false },
		{ label: 'Password', value: 'password', selected: false },
	]);
	const [selectedOAuthGrantTypeOption, setOAuthGrantTypeOption] = useState(null)

	const [selectedCheckBox, setSelectedCheckBox] = useState([]);
	const [payload, setPayload] = useState();
	const [inlineError, setInlineError] = useState(false)
	const [isCustomHeadersEnabled, setIsCustomHeadersEnabled] = useState(false);
	const [customHeadersData, setCustomHeadersData] = useState([]);
	const [customHeaderErrors, setCustomHeaderErrors] = useState([]);
	const [customHeaderModalDetail, setCustomHeaderModalDetail] = useState({ header: "", body: "" });
	const [customHeaderInputValues, setCustomHeaderInputValues] = useState({});
	const [httpHeaderKeyError, setHttpHeaderKeyError] = useState(null);
	const [apiKeyValueError, setApiKeyValueError] = useState(null);

	const httpHeaderKey = watch("api_key_header");
	const apiKeyValue = watch("api_key_value");

	const customHeaderInputValuesRef = useRef(customHeaderInputValues);
	customHeaderInputValuesRef.current = customHeaderInputValues;

	/*=================================================
		Validation Logic for http header key and value validation with respect to custom headers
	/================================================*/

	const validateHttpHeaderKey = useCallback((headerKey, customHeaders) => {
		const isHttpHeaderKeyDirty = dirtyFields.api_key_header;
		if (!isHttpHeaderKeyDirty || authType !== "API_KEY") {
			setHttpHeaderKeyError(null);
			return;
		}
	
		const formatError = validateCustomHeaderKey(headerKey);

		if (formatError && formatError !== CUSTOM_HEADER_ERROR_MESSAGES.CANNOT_BE_EMPTY_KEY) {
			setHttpHeaderKeyError(formatError);
			return;
		}
	
		// Always run duplicate check when there's no format error (or only empty key error)
		const existsInCustomHeaders = customHeaders.some(header => header.key === headerKey);
		const existsInInputValues = customHeaderInputValuesRef.current?.key === headerKey;
		const hasDuplicate = existsInCustomHeaders || existsInInputValues;
		
		if (isCustomHeadersEnabled && hasDuplicate) {
			setHttpHeaderKeyError(CUSTOM_HEADER_ERROR_MESSAGES.KEY_ALREADY_EXISTS);
		} else {
			setHttpHeaderKeyError(null);
		}
	}, [isCustomHeadersEnabled, dirtyFields.api_key_header, httpHeaderKey, authType]);

	const validateApiKeyValue = useCallback((keyValue) => {
		const isApiKeyValueDirty = dirtyFields.api_key_value;
		if (!isApiKeyValueDirty) {
			return;
		}

		const formatError = validateCustomHeaderValue(keyValue);
		if (formatError && formatError !== CUSTOM_HEADER_ERROR_MESSAGES.CANNOT_BE_EMPTY_VALUE) {
			setApiKeyValueError(formatError);
		}else{
			setApiKeyValueError(null);
		}
	}, [dirtyFields.api_key_value]);

	useEffect(() => {
		if(isCustomHeadersFeatureEnabled){
			validateHttpHeaderKey(httpHeaderKey, customHeadersData);
		}
	}, [httpHeaderKey, validateHttpHeaderKey]);

	useEffect(() => {
		if(isCustomHeadersFeatureEnabled){
			validateApiKeyValue(apiKeyValue);
		}
	}, [apiKeyValue, validateApiKeyValue]);

	// Error clearing when customHeaderInputValues or customHeadersData changes
	useEffect(() => {
		if(isCustomHeadersFeatureEnabled) {
			if(httpHeaderKeyError === CUSTOM_HEADER_ERROR_MESSAGES.KEY_ALREADY_EXISTS) {
				const existsInCustomHeaders = customHeadersData.some(header => header.key === httpHeaderKey);
				const existsInInputValues = customHeaderInputValues?.key === httpHeaderKey;
				if (!existsInCustomHeaders && !existsInInputValues) {
					const formatError = validateCustomHeaderKey(httpHeaderKey);
					if(!formatError){
						setHttpHeaderKeyError(null);
					}
				}
			}
		}
	}, [customHeaderInputValues, httpHeaderKeyError, customHeadersData, httpHeaderKey, isCustomHeadersFeatureEnabled]);

	// Clear httpHeaderKeyError if contains KEY_ALREADY_EXISTS error when isCustomHeadersEnabled is enabled or disabled
	useEffect(() => {
		if(isCustomHeadersFeatureEnabled){
			if (!isCustomHeadersEnabled) {
				return;
			}

			if(httpHeaderKeyError === CUSTOM_HEADER_ERROR_MESSAGES.KEY_ALREADY_EXISTS || httpHeaderKeyError === null){
				setHttpHeaderKeyError(null);
			}
		}
	}, [isCustomHeadersEnabled]);

	/*=================================================
		Error Modal
	/================================================*/
	const [error, setError] = useState(false)
	function handleError() {
		setError()
	}

	/*=================================================
		API
	/================================================*/
	const { config, error: erroConfig } = useConfig()
	const { fetch: fetchPublicKey, error: errorLicenseKey } = usePublicKey()

	async function patchData() {
		const { editingDE } = existingEditingDE();

		let _inputUrl = currentState.data?.endpoint ? currentState.data?.endpoint.url : currentState.data?.endpoints?.[editingDE[0]]?.url
		if (_inputUrl) {
			setInputUrl(_inputUrl);
			validate(_inputUrl)
		}

		let _auth = currentState.data?.endpoint ? currentState.data?.endpoint.auth : currentState.data?.endpoints?.[editingDE[0]]?.auth;
		let _authKey = Object.keys(_auth).filter(s => s !== 'type')[0]
		let _authType = _auth.type;
		setAuthType(_authType)
		setOption(_authType ? ssAuthType.find(s => s.value === _authType)?.label : "Select type")

		let formValue = {
			url: currentState.data?.endpoint ? currentState.data?.endpoint?.url : currentState.data?.endpoints?.[editingDE[0]]?.url
		};

		switch (_authType) {
			case 'API_KEY':
				formValue['api_key_header'] = _authKey;
				formValue['api_key_value'] = _auth[_authKey];
				break;
			case 'JWT_SYM':
				formValue['jwt_auth_token'] = _auth.Authorization?.split(' ')?.[1] ?? '';
				break;
			case 'JWT':
				formValue['jwt_jwt_iss'] = _auth.iss;
				break;
			case 'JWT_JWE':
				formValue['jwt_jwe_jwt_iss'] = _auth?.jwt?.iss;
				formValue['jwt_jwe_ss_public_key'] = _auth?.jwe?.publicKey;
				break;
			case 'OAUTH':
				setOAuthGrantTypeOption(_auth.grant_type)
				formValue['grant_type'] = _auth.grant_type
				formValue['client_id'] = _auth.client_id
				formValue['client_secret'] = _auth.client_secret
				formValue['username'] = _auth?.username
				formValue['password'] = _auth?.password
				formValue['token_url'] = _auth.tokenUrl
				formValue['scope'] = _auth.scope
				formValue['expiration'] = Number(_auth?.expiration) || _auth?.expiration
				break;
		}
		reset(formValue);

		setSelectedConfig(currentState.data?.type);
	}

	useEffect(() => {
		if (selectedConfig === 'MULTI')
			setupCheckbox();
	}, [selectedConfig]);

	async function setupCheckbox() {
		const { existingDE, editingDE } = existingEditingDE();
		let hasDESelected = false;
		if (type === provide) {
			const list = config?.produces?.map(s => {
				hasDESelected = hasDESelected || editingDE.includes(s.id) && existingDE.includes(s.id);
				return {
					"id": s.id,
					"name": s.name,
					"$selected": editingDE.includes(s.id) && existingDE.includes(s.id),
					"$disable": (!editingDE.includes(s.id)) && existingDE.includes(s.id)
				}
			})
			setCheckboxDataElements(list)
		}
		if (type === receive) {
			const list = config?.consumes?.map(s => {
				hasDESelected = hasDESelected || editingDE.includes(s.id) && existingDE.includes(s.id);
				return {
					"id": s.id,
					"name": s.name,
					"$selected": editingDE.includes(s.id) && existingDE.includes(s.id),
					"$disable": (!editingDE.includes(s.id)) && existingDE.includes(s.id)
				}
			})
			setCheckboxDataElements(list)
		}

		if (hasDESelected)
			setSelectedCheckBox([1]);
	}

	async function getPitstopPublicKey() {
		setPitstopPublicKey(await fetchPublicKey())
	}

	const init = useCallback(() => {
		let configLists = [{
			id: 1,
			value: "DEFAULT",
			name: "Default Configuration",
			$selected: currentState.data?.type === "DEFAULT" ? true : false,
		},
		{
			id: 2,
			value: "SINGLE",
			name: "Single Endpoint",
			$selected: currentState.data?.type === "SINGLE" ? true : false,
		}]

		if (type === provide || type === receive) {
			configLists.push({
				id: 3,
				value: "MULTI",
				name: "Custom",
				$selected: currentState.data?.type === "MULTI" ? true : false,
			})
		}

		// Pre select option, if props passed in
		if (currentState.data?.type) {
			setSelectedConfig(currentState.data?.type);
		}

		setConfigLists(configLists);

		getPitstopPublicKey();
		if (currentState.mode) {
			setPageTitle(`Edit ${TypeEnum[type]} API Configuration`)
			patchData();
		} else {
			setPageTitle(`Add ${TypeEnum[type]} API Configuration`)
		}
	});

	useEffect(() => {
		init();
			
		if (!isCustomHeadersFeatureEnabled) return;
		
		const data = currentState?.data;
		const isMultiEdit = currentState.mode && data?.type === "MULTI";
		
		let endpointData;
		
		if (isMultiEdit) {
			const { editingDE } = existingEditingDE();
			endpointData = data?.endpoints?.[editingDE[0]];
		} else {
			endpointData = data?.endpoint;
		}
	
		const headers = endpointData?.transform?.header ?? [];
		const existingCustomHeaders = Object.entries(headers).map(([key, value]) => ({
			key,
			value,
		}));
				
		setCustomHeadersData(existingCustomHeaders);
		if(existingCustomHeaders.length > 0 || endpointData?.transform) {
			setIsCustomHeadersEnabled(true);
		}
	}, [])

	useEffect(() => {
		setError(erroConfig)
		setError(errorLicenseKey)
	}, [erroConfig, errorLicenseKey])

	/*=================================================
		Steps
	/================================================*/
	const stepArr= [
		{stepTitle:t("selectConfigurationType")},
		{stepTitle:t("selectAuthMethod")}
	]

	const [steps, _setSteps] = useState([...stepArr])
	const [step, setStep] = useState(1)

	// Sync form URL value with inputUrl state when navigating back to step 1
	useEffect(() => {
		if (step === 1 && inputUrl && !currentState.mode) {
			setValue('url', inputUrl);
		}
	}, [step, inputUrl, setValue, currentState.mode]);


	function goToStep(newStep) {
		if (newStep < 1 || newStep > steps.length) {
			return
		}
		setStep(newStep)
	}

	function prevStep() {
		goToStep(step - 1)
	}

	function nextStep() {
		goToStep(step + 1)
	}

	function handleValue(option) {
		setAuthType(option.value)
		setOption(option.label)
	}

	/*=================================================
		Configuration List
	/================================================*/

	const [configLists, setConfigLists] = useState([])

	const handleUpdateConfigSelect = (item) => {
		if (currentState.data?.mapping !== "MULTI") {
			const index = configLists.findIndex(config => config.id === item.id);
			const updatedItems = produce(configLists, draft => {
				draft.forEach(config => config.$selected = false)
				draft[index].$selected = true
			})
			// setInputUrl("");
			setSelectedConfig(item.value);
			setConfigLists(updatedItems);
		}
	}

	const ConfigurationList = () => {
		const list = configLists.map((config, index) => {
			return (
				<div className="checkbox-selector-box__col checkbox-selector-box3 checkbox-selector-box__col_remove-flex-basis" key={index}>
					<SelectorBox3 label={config.name}
						submit={() => handleUpdateConfigSelect(config)}
						active={config.$selected}
					/>
				</div>
			)
		})

		return (
			<div className='checkbox-selector-box__cols'>
				{list}
			</div>
		)
	}

	/*=================================================
		Functions
	/================================================*/
	const handleCheck = (event) => {
		const index = checkboxDataElements.findIndex(item => item.id === event.target.id)
		const updatedItem = produce(checkboxDataElements, (draft) => {
			draft[index].$selected = !draft[index].$selected
		})
		const selected = updatedItem.filter(item => item.$selected === true);
		setCheckboxDataElements(updatedItem)
		setSelectedCheckBox(selected);
	}

	async function formHandler(data) {
		let auth = {};
		const authTypeValues = {
			"NONE": {
				"type": "NONE",
			},
			'API_KEY': {
				"type": "API_KEY",
				[data.api_key_header]: data.api_key_value
			},
			'JWT_SYM': {
				"type": "JWT_SYM",
				"Authorization": "Bearer " + data.jwt_auth_token
			},
			'JWT': {
				"type": "JWT",
				"alg": data.jwt_jwt_alg,
				"iss": data.jwt_jwt_iss
			},
			'JWT_JWE': {
				"type": "JWT_JWE",
				"jwt": {
					"alg": data.jwt_jwe_jwt_alg,
					"iss": data.jwt_jwe_jwt_iss,
				},
				"jwe": {
					"alg": data.jwt_jwe_jwe_alg,
					"enc": data.jwt_jwe_jwe_enc,
					"publicKey": data.jwt_jwe_ss_public_key
				}
			},
			'OAUTH': {
				"type": "OAUTH",
				"grant_type": data.grant_type,
				"client_id": data.client_id,
				"client_secret": data.client_secret,
				"tokenUrl": data.token_url,
				"scope": data.scope || 'openid',
				"expiration": Number(data.expiration) || 1800,
			}
		}

		if (authType === 'OAUTH' && data?.grant_type === 'password') {
			authTypeValues.OAUTH['username'] = data.username
			authTypeValues.OAUTH['password'] = data.password
		}

		auth = authTypeValues[authType]

		const hasErrorsInDraftCustomHeaders = customHeaderErrors.some(error => 
			error.cellId === "newKey_key" || error.cellId === "newValue_value"
		);

		const hasValidDraftCustomHeaders = customHeaderInputValues?.key?.length > 0 && customHeaderInputValues?.value?.length > 0 && !hasErrorsInDraftCustomHeaders;
		
		const customHeadersToProcess = hasValidDraftCustomHeaders ? [customHeaderInputValues, ...customHeadersData] : customHeadersData;
		
		const transform =
			isCustomHeadersFeatureEnabled && isCustomHeadersEnabled
				? {
						header: customHeadersToProcess.reduce((acc, { key, value }) => {
							acc[key.trim()] = value.trim();
							return acc;
						}, {}),
				}
				: undefined;

		let payload = {
            "type": selectedConfig,
            "endpoint": {
                "url": inputUrl,
                auth,
                ...transform && { transform }
            },
        }

		if (selectedConfig === "MULTI") {
			const rawItems = currentState.data;
			const { editingDE } = existingEditingDE();

			const newArray = checkboxDataElements.reduce((acc, current, _index) => {
				if (current.$selected) {
					const newItem = {
						[current.id]:
						{
							"url": inputUrl,
							auth,
							...transform && { transform }
						}
					}
					acc = { ...acc, ...newItem }
					return acc
				} else if (rawItems?.endpoints && rawItems?.endpoints?.hasOwnProperty(current.id)) {
					if (!editingDE.includes(current.id)) {
						const newItem = {
							[current.id]: rawItems.endpoints[current.id]
						}
						acc = { ...acc, ...newItem }
					}

					return acc
				}
				return acc
			}, {})

			let newTempArray
			if (currentState.mode) {
				newTempArray = { ...newArray }
			} else if (currentState.data?.type === 'MULTI') {
				newTempArray = { ...newArray, ...rawItems?.endpoints }
			} else {
				newTempArray = { ...newArray, ...rawItems?.endpoints }
			}

			payload = {
				"type": selectedConfig,
				"endpoints": newTempArray,
			}

		}
		setPayload(payload);

		if (isCustomHeadersFeatureEnabled && isCustomHeadersEnabled) {
			const hasOnlyDuplicateKeyErrors = customHeaderErrors.length > 0 && customHeaderErrors.every(error => error.errorMessage === CUSTOM_HEADER_ERROR_MESSAGES.KEY_ALREADY_EXISTS);
			const hasOtherErrors = customHeaderErrors.length > 0 && !hasOnlyDuplicateKeyErrors;

			let modalDetail = null;
		
			if(customHeadersData.length === 0 && hasValidDraftCustomHeaders){
				showApiSubmitModal();
			} else if (customHeadersData.length === 0 && !hasErrorsInDraftCustomHeaders) {
				modalDetail = CUSTOM_HEADER_MODAL_DETAILS.REQUIRED;
			} else if (hasOnlyDuplicateKeyErrors) {
				modalDetail = CUSTOM_HEADER_MODAL_DETAILS.DUPLICATE_KEY;
			} else if (hasOtherErrors) {
				modalDetail = CUSTOM_HEADER_MODAL_DETAILS.INVALID_INPUT;
			}
		
			if (modalDetail) {
				setCustomHeaderModalDetail(modalDetail);
				showCustomHeadersModal();
			} else {
				showApiSubmitModal();
			}
		} else {
			showApiSubmitModal();
		}
	}

	async function updatePitstopConfig(payload) {
		hideApiSubmitModal();
		const url = `${type}/${currentState.sourceSystemId}`
		const [error, _result] = await api.update(url, payload);

		if (error) {
			return setError(error?.message || "Failed to update Pitstop Config")
		}

		goTo(`/configuration/api-configuration/`, { tab: 2 })
		addToastMessage(currentState.mode ? "API Configuration successfully updated." : "API Configuration successfully added.", 'success')
	}

	const validate = (data) => {
		if (validateURL(data)) {
			setInlineError(false);
		} else {
			setInlineError(true);
			return;
		}

		/* If everything went good then we're marking error as false */
		setInlineError(false);
	}

	const isAddDisabled = !isValid || selectedOption === 'Select type' || httpHeaderKeyError || apiKeyValueError; 

	return (
		<>
			<div className="title-header">
				<div className="title-header__left">
					<div className="title-header__title">
						{pageTitle}
					</div>
				</div>
				<div className="title-header__right">
				</div>
			</div>

			<Stepper steps={steps} currentStep={step-1}/>


			<hr />

			<form id="authentication" onSubmit={handleSubmit(data => formHandler(data))}>
				{step === 1 && (
					<>
						<ConfigurationList />
						{
							(selectedConfig) && (
								<>
									<div className="pitstop-sourcesystem__cols">
										<div className="pitstop-sourcesystem__col">
											<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
												Source System URL
											</div>
											<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap ">
												<div className="pitstop-sourcesystem__col__right_input">
													<Input
														name="url"
														register={register({
															required: "This field is mandatory",
															validate: {
																validateUrl: v => validate(v.target?.value ?? inputUrl) || "Source system URL is not valid"
															}
														})}
														data-testid="inputUrl"
														error={inlineError}
														errorMessage={"Source system URL is not valid"}
														onBlur={(e) => { e.target.value = e.target.value.trim() }}
														onChange={(e) => {
															setInputUrl(e.target.value);
															validate(e.target.value);
														}}
													/>
												</div>
											</div>
										</div>
										{
											configLists[2]?.$selected && (
												<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
													<div className="pitstop-sourcesystem__col__left">
														Data Elements
													</div>
													<div className="pitstop-sourcesystem__col__right">
														Apply to the following data elements
														<div className="pitstop-sourcesystem__checkboxes" data-testid="selectorDE">
															{
																checkboxDataElements?.map((dataElement, index) => {
																	return (dataElement['$disable'] ?
																		<div className="pitstop-sourcesystem__checkbox" key={index} >
																			<label className="pitstop-sourcesystem__checkbox-container pitstop-sourcesystem__checkbox-container-disabled" htmlFor={dataElement.id}>{dataElement.name}
																				<input
																					type="checkbox"
																					checked={dataElement.$selected}
																					disabled={dataElement.$disable}
																					id={dataElement.id}
																					onChange={(e) => handleCheck(e)}
																				/>
																				<span className="pitstop-sourcesystem__checkbox-content pitstop-sourcesystem__checkbox-content-disabled"></span>
																			</label>
																		</div> :
																		<div className="pitstop-sourcesystem__checkbox" key={index} >
																			<label className="pitstop-sourcesystem__checkbox-container" htmlFor={dataElement.id}>{dataElement.name}
																				<input
																					type="checkbox"
																					checked={dataElement.$selected}
																					disabled={dataElement.$disable}
																					id={dataElement.id}
																					onChange={(e) => handleCheck(e)}
																				/>
																				<span className="pitstop-sourcesystem__checkbox-content"></span>
																			</label>
																		</div>
																	)
																})
															}
														</div>
													</div>
												</div>
											)
										}
									</div>
								</>
							)
						}
					</>
				)}

				{step === 2 && (
					<div className="pitstop-sourcesystem__cols">
						<div className="pitstop-sourcesystem__col">
							<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
								Authentication Type
							</div>
							<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap pitstop-sourcesystem__col__right_dropdown">
								<Dropdown value={selectedOption}>
									{ssAuthType.map((option, index) => {
										return (
											<Dropdown.Item key={index} onClick={() => handleValue(option)}>
												{option.label}
											</Dropdown.Item>
										)
									})}
								</Dropdown>
							</div>
						</div>
						{
							(authType === "API_KEY") && (
								<>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											HTTP Header Key
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input 
													name="api_key_header" 
													type="text" 
													ref={register({ required: authType === "API_KEY" })} 
													onKeyDown={(e) => {
														if (e.key === ' ') {
															e.preventDefault();
														}
													}}
												/>
												{isCustomHeadersFeatureEnabled && httpHeaderKeyError && (
													<div className="DS__error__wrapper">
														<ErrorInfoCircle
															className="DS__error__icon"
															data-testid="error-info-icon"
														/>
														<div className="DS__error__message">
															{httpHeaderKeyError}
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											API Key
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="api_key_value" type="text" ref={register({ required: authType === "API_KEY" })} />
												{isCustomHeadersFeatureEnabled && apiKeyValueError && (
													<div className="DS__error__wrapper">
														<ErrorInfoCircle
															className="DS__error__icon"
															data-testid="error-info-icon"
														/>
														<div className="DS__error__message">
															{apiKeyValueError}
														</div>
													</div>
												)}
											</div>
										</div>
									</div>
								</>
							)
						}
						{
							(authType === "JWT_SYM") && (
								<>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											Authorization
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right_input_wrap">
											{/* <span>Bearer </span>  */}
											<div className="pitstop-sourcesystem__col__right_input_bearer">
												<input disabled value="Bearer" />
											</div>
											<div className="pitstop-sourcesystem__col__right_input_authorization">
												<input name="jwt_auth_token" type="text" ref={register({ required: authType === "JWT_SYM" })} />
											</div>
										</div>
									</div>
								</>
							)
						}
						{
							(authType === "JWT") && (
								<>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											JWT Algorithm
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right_input pitstop-sourcesystem__col__right_input_wrap">
											<Select containerProps={{ style: { width: rem(366) } }} selectProps={{ value: "RS256", name: "JWT_alg_select", disabled: true }}>
												<option value="" disabled>{t("select")}</option>
												<option value="RS256">RS256</option>
											</Select>
											<input type="hidden" name="jwt_jwt_alg" value="RS256" ref={register({ required: authType === "JWT" })} />
										</div>
									</div>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											Issuer
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="jwt_jwt_iss" type="text" ref={register({ required: authType === "JWT" })} />
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Public Key
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right--flex_end pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<textarea disabled value={pitstopPublicKey?.signPublicKey || ""} />
												<textarea name="jwt_ps_public_key" defaultValue={pitstopPublicKey?.signPublicKey || ""} style={{ display: "none" }} ref={register({ required: authType === "JWT" })} />
											</div>

											<div className="pitstop-sourcesystem__col_button">
												<Button ghost text="Copy" type="button" submit={() => { navigator.clipboard.writeText(pitstopPublicKey?.signPublicKey) }} />
											</div>
										</div>
									</div>
								</>
							)
						}
						{
							(authType === "JWT_JWE") && (
								<>

									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											JWT Issuer
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="jwt_jwe_jwt_iss" type="text" ref={register({ required: authType === "JWT_JWE" })} />
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											JWT RSA Algorithm
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<Select containerProps={{ style: { width: rem(366) } }} selectProps={{ value: "RS256", name: "JWE_alg_select", disabled: true }}>
												<option value="" disabled>{t("select")}</option>
												<option value="RS256">RS256</option>
											</Select>
											<input type="hidden" name="jwt_jwe_jwt_alg" value="RS256" ref={register({ required: authType === "JWT_JWE" })} />

										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											JWE RSA Algorithm
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<Select containerProps={{ style: { width: rem(366) } }} selectProps={{ value: "RSA-OAEP-256", name: "JWE_alg_select", disabled: true }}>
												<option value="" disabled>{t("select")}</option>
												<option value="RSA-OAEP-256">RSA-OAEP-256</option>
											</Select>
											<input type="hidden" name="jwt_jwe_jwe_alg" value="RSA-OAEP-256" ref={register({ required: authType === "JWT_JWE" })} />
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Content Encryption Algorithm
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<Select containerProps={{ style: { width: rem(366) } }} selectProps={{ value: "A256CBC-HS512", name: "JWE_enc_select", disabled: true }}>
												<option value="" disabled>{t("select")}</option>
												<option value="A256CBC-HS512">A256CBC-HS512</option>
											</Select>
											<input type="hidden" name="jwt_jwe_jwe_enc" value="A256CBC-HS512" ref={register({ required: authType === "JWT_JWE" })} />
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Pitstop Public Key
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right--flex_end pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<textarea disabled value={pitstopPublicKey?.signPublicKey || ""} />
												<textarea name="jwt_ps_public_key" defaultValue={pitstopPublicKey?.signPublicKey || ""} style={{ display: "none" }} ref={register({ required: authType === "JWT" })} />
											</div>

											<div className="pitstop-sourcesystem__col_button">
												<Button ghost text="Copy" type="button" submit={() => { navigator.clipboard.writeText(pitstopPublicKey?.signPublicKey) }} />
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Source System Public Key
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col_right_text">
												Upload your public key below. Refer to the <span className="link link--color">documentation</span> for help.
											</div>
											<div >
												<div className="pitstop-sourcesystem__col__right_input pitstop-sourcesystem__col__right_input-textarea">
													<textarea name="jwt_jwe_ss_public_key" ref={register({ required: authType === "JWT_JWE" })} autoComplete="off" />
												</div>
											</div>
										</div>
									</div>
								</>
							)
						}
						{
							(authType === "OAUTH") && (
								<>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											Grant Type
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right--flex pitstop-sourcesystem__col__right_input_wrap">
											<Dropdown style={{ width: rem(366) }} value={oAuthGrantTypeOptions.find(s => s.value === selectedOAuthGrantTypeOption)?.label ?? 'Select'}>
												{oAuthGrantTypeOptions.map(({ label, value, selected, disabled }, index) => {
													return (
														<Dropdown.Item key={index} disabled={disabled} selected={selected} onClick={() => {
															setOAuthGrantTypeOption(value)
															setValue('grant_type', value, { shouldValidate: true })
														}}>
															{label}
														</Dropdown.Item>
													)
												})}
											</Dropdown>
											<input type="hidden" name="grant_type" value={selectedOAuthGrantTypeOption} ref={register({ required: authType === "OAUTH" })} />
										</div>
									</div>
									<div className="pitstop-sourcesystem__col">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem_col_left_label">
											Client ID
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="client_id" type="text" ref={register({ required: authType === "OAUTH" })} />
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Client Secret
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="client_secret" type="text" ref={register({ required: authType === "OAUTH" })} />
											</div>
										</div>
									</div>

									{selectedOAuthGrantTypeOption === 'password' &&
										<>
											<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
												<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
													Username
												</div>
												<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
													<div className="pitstop-sourcesystem__col__right_input">
														<input name="username" type="text" ref={register({ required: authType === "OAUTH" && selectedOAuthGrantTypeOption === 'password' })} />
													</div>
												</div>
											</div>
											<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
												<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
													Password
												</div>
												<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
													<div className="pitstop-sourcesystem__col__right_input">
														<input name="password" type="text" ref={register({ required: authType === "OAUTH" && selectedOAuthGrantTypeOption === 'password' })} />
													</div>
												</div>
											</div>
										</>
									}

									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Token URL
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="token_url" type="text" ref={register({ required: authType === "OAUTH" })} />
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Scope
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="scope" type="text" placeholder='openid' defaultValue={"openid"} ref={register({ required: false })} />
											</div>
										</div>
									</div>
									<div className="pitstop-sourcesystem__col pitstop-sourcesystem__col--top-align">
										<div className="pitstop-sourcesystem__col__left pitstop-sourcesystem__col__left--margin-top pitstop-sourcesystem_col_left_label">
											Expiration (seconds)
										</div>
										<div className="pitstop-sourcesystem__col__right pitstop-sourcesystem__col__right_input_wrap">
											<div className="pitstop-sourcesystem__col__right_input">
												<input name="expiration" type="number" placeholder='1800' defaultValue={1800} ref={register({ required: false })} />
											</div>
										</div>
									</div>
								</>
							)
						}

						{isCustomHeadersFeatureEnabled && authType.length > 0 && (
							<>
								<hr className='custom-headers__separator'/>
								<CustomHeadersToggle
									isCustomHeadersEnabled={
										isCustomHeadersEnabled
									}
									setIsCustomHeadersEnabled={
										setIsCustomHeadersEnabled
									}
									customHeaderErrors={customHeaderErrors}
									customHeadersData={customHeadersData}
									customHeaderInputValues={customHeaderInputValues}
								/>
							</>
						)}
						{isCustomHeadersFeatureEnabled && isCustomHeadersEnabled && 
							<CustomHeadersTable authType={authType} httpHeaderKey={httpHeaderKey} httpHeaderKeyError={httpHeaderKeyError} customHeadersData={customHeadersData} setCustomHeadersData={setCustomHeadersData} customHeaderErrors={customHeaderErrors} setCustomHeaderErrors={setCustomHeaderErrors} inputValues={customHeaderInputValues} setInputValues={setCustomHeaderInputValues}/>
						}
					</div>
				)}
			</form>

			{step === 1 && selectedConfig &&
			<div className='pitstop-sourcesystem-footer'>
				{selectedConfig === "DEFAULT" && <span>Tip: Default Configuration will follow SGTraDex’s URL conventions, where you will only need to configure your API’s base URL.</span>}
				{selectedConfig === "SINGLE" && <span>Tip: The Single Endpoint is for the organizations who would like to use just one single URL for providing / receiving all data elements.</span>}
				{selectedConfig === "MULTI" && <span>Tip: The Custom URL is for the organizations who wants the liberty to define their custom URLs for each data element in provide and receive.flow.</span>}
			</div>}
			<div className="DS__layout__footer">
				<div className="layout-default__sticky-actions">
					<div className="layout-default__sticky-actions__left">
						<Button
							customeHover
							btnText
							text="Cancel"
							submit={() => {
								showapiConfigCancelModal()
							}}
						/>
					</div>
					<div className="layout-default__sticky-actions__right">
						{step === 1 &&
							<div className="layout-default__sticky-actions__right-flex ">
								<Button sizing='Medium' text='Next' full maxWidth='154'
									submit={() => {
										nextStep()
									}}
									disabled={!selectedConfig || inputUrl === "" || inlineError !== false || (selectedConfig === "MULTI" ? selectedCheckBox.length === 0 ? true : false : false)}
								/>
							</div>
						}

						{step === steps.length &&
							<div className="layout-default__sticky-actions__right-flex ">
								<Button sizing='Medium' text='Previous' ghost full maxWidth='154'
									submit={() => {
										prevStep();
										hideCustomHeadersModal();
										hideApiSubmitModal();
									}}
								/>
								<span style={{ width: rem(20), display: 'inline-block' }}></span>
								<Button sizing='Medium' form="authentication" text="Submit" id="api-configuration-add-provide-api-configuration" full maxWidth='154' disabled={isAddDisabled} />
							</div>
						}
					</div>
				</div>
			</div>

			{/* Cancel API CONFIG */}
			<Modal visible={isVisible} variant='medium'  close={hideapiConfigCancelModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon DS__icon--theme'}>
											<IconAPIConfiguration />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											Cancel API Configuration
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="delete-source-system">
								<div className="default-source-system__message">
									<span>Are you sure you want to cancel API configuration?</span>
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								customeHover
								btnText
								text="Cancel"
								submit={() => {
									hideapiConfigCancelModal()
								}}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<button className="button--rounded" onClick={() => {
									setSelectedConfig("");
									hideapiConfigCancelModal();
									goTo(`/configuration/api-configuration`, { tab: 2 });
							}}>Confirm</button>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{/* Submit API CONFIG */}
			<Modal visible={isSubmitModalVisible} variant='medium'  close={hideApiSubmitModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconAPIConfiguration />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{currentState.mode ? 'Edit' : 'Add'} API Configuration
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="delete-source-system">
								<div className="default-source-system__message">
									{currentState.mode ? <span>Are you sure to save your changes?</span> : <>
										<span>You are adding a new API configuration.</span>
										<span>Are you sure you want to submit?</span>
									</>}
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Left>
							<Button
								customeHover
								btnText
								text="Cancel"
								submit={() => hideApiSubmitModal()}
							/>
						</CardConfigure.Footer.Left>
						<CardConfigure.Footer.Right>
							<button className="button--rounded" onClick={() => {
									updatePitstopConfig(payload);
								}}>Confirm</button>
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			{/* Custom Headers Error Modal */}
			<Modal visible={isCustomHeadersModalVisible} variant='small'  close={hideCustomHeadersModal}>
				<CardConfigure >
					<CardConfigure.Header>
						<CardConfigure.Header.Title>
							<div className="card-configure__header__left">
								<div className="card-configure__title">
									<div className="card-configure__title__left">
										<div className={'card-configure__icon'}>
											<IconVerificationIndicator  />
										</div>
									</div>
									<div className="card-configure__title__right">
										<div className="card-configure__title__right__top">
											{customHeaderModalDetail.header}
										</div>
									</div>
								</div>
							</div>
						</CardConfigure.Header.Title>
					</CardConfigure.Header>
					<CardConfigure.Body>
						<CardConfigure.Body.Col>
							<div className="delete-source-system">
								<div className="default-source-system__message">
									{customHeaderModalDetail.body}
								</div>
							</div>
						</CardConfigure.Body.Col>
					</CardConfigure.Body>
					<CardConfigure.Footer>
						<CardConfigure.Footer.Right>
							<Button text="Back"
								submit={() => {
									hideCustomHeadersModal();
									setCustomHeaderModalDetail({
										header: "",
										body: "",
									})
								}} />
						</CardConfigure.Footer.Right>
					</CardConfigure.Footer>
				</CardConfigure>
			</Modal>

			<Toast2 show={error} errorMessage={error} close={() => { handleError() }} />
		</>
	)
}

export default Page
